<template>
    
    <v-dialog 
        v-model="display" 
        width="500" 
        persistent
    >
           <MessageOverlay ref="overlay" @end="disconnect"/>

            <v-card>
                <v-card-title class="text-h5">{{ $vuetify.lang.t('$vuetify.account.changePassword.passwordchange') }}</v-card-title>
                <v-card-text class="pb-0">
                    <v-form ref="formEditPassword" v-model="passwordFormValidation" lazy-validation>
                        <v-text-field
                            v-model="currentPassword.value"
                            outlined
                            required
                            :rules="currentPassword.rules"
                            :label="$vuetify.lang.t('$vuetify.account.changePassword.currentpassword')+'*'"
                            :type="currentPassword.show ? 'text' : 'password'"
                            :append-icon="currentPassword.focus ? currentPassword.show ? 'mdi-eye-off' : 'mdi-eye' : undefined"
                            @click:append="currentPassword.show = !currentPassword.show"
                            @focus="currentPassword.focus = true"
                            @blur="currentPassword.focus = false"
                        ></v-text-field>
                        <v-text-field
                            v-model="newPassword.value"
                            outlined
                            required
                            :rules="newPassword.rules"
                            :label="$vuetify.lang.t('$vuetify.account.changePassword.newpassword')+'*'"
                            :type="newPassword.show ? 'text' : 'password'"
                            :append-icon="newPassword.focus ? newPassword.show ? 'mdi-eye-off' : 'mdi-eye' : undefined"
                            @click:append="newPassword.show = !newPassword.show"
                            @focus="newPassword.focus = true"
                            @blur="newPassword.focus = false"
                        ></v-text-field>
                        <v-text-field
                            v-model="confirmationPassword.value"
                            outlined
                            required
                            :rules="confirmationPassword.rules"
                            :label="$vuetify.lang.t('$vuetify.account.changePassword.passwordconfirmation')+'*'"
                            :type="confirmationPassword.show ? 'text' : 'password'"
                            :append-icon="confirmationPassword.focus ? confirmationPassword.show ? 'mdi-eye-off' : 'mdi-eye' : undefined"
                            @click:append="confirmationPassword.show = !confirmationPassword.show"
                            @focus="confirmationPassword.focus = true"
                            @blur="confirmationPassword.focus = false"
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        :disabled="!passwordFormValidation"
                        :class="{ 'gradient-wintech': (passwordFormValidation) }"
                        @click="savePassword"
                    >
                        <v-icon left>mdi-content-save</v-icon>
                        {{ $vuetify.lang.t('$vuetify.account.changePassword.save') }}
                    </v-btn>
                    <v-btn
                        color="error"
                        @click="cancelPasswordDialog"
                    >
                        <v-icon left>mdi-cancel</v-icon>
                        {{ $vuetify.lang.t('$vuetify.account.changePassword.cancel') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>
<script>
import axios from 'axios';
import { sha3_512 } from 'js-sha3';
import { mapGetters, mapActions } from 'vuex';
import MessageOverlay from '@/components/Overlay/MessageOverlay.vue'
export default {
    name: "NewPassword",
    components: {MessageOverlay},
    props: {
        display: Boolean,
    },
    data() {
        return {
           
            currentPassword: {
                value: "",
                show: false,
                focus: false,
                rules: [
                    v => !!v ||  this.$vuetify.lang.t('$vuetify.account.changePassword.actualpasswordisrequired'),
                ]
            },
            newPassword: {
                value: "",
                show: false,
                focus: false,
                rules: [
                    v => !!v ||  this.$vuetify.lang.t('$vuetify.account.changePassword.passwordisrequired'),
                    v => /^(?=.*[A-Z])/.test(v) || this.$vuetify.lang.t('$vuetify.account.changePassword.yourpasswordshouldcontainatleastoneuppercase'),
                    v => /^(?=.*\d)/.test(v) || this.$vuetify.lang.t('$vuetify.account.changePassword.yourpasswordshouldcontainatleastonedigit'),
                    v => /^(?=.*[a-z])/.test(v) || this.$vuetify.lang.t('$vuetify.account.changePassword.yourpasswordshouldcontainatleastonelowercase'),
                    v => /^(?=.*[!@#$%^&*])/.test(v) || this.$vuetify.lang.t('$vuetify.account.changePassword.yourpasswordmustcontainatleastonespecialcharacter'),
                    v => /^[a-zA-Z0-9!@#$%^&*]{8,}/.test(v) || this.$vuetify.lang.t('$vuetify.account.changePassword.yourpasswordshouldcontainatleast8characters'),
                ]
            },
            confirmationPassword: {
                value: "",
                show: false,
                focus: false,
                rules: [
                    v => !!v ||  this.$vuetify.lang.t('$vuetify.account.changePassword.confirmationisrequired'),
                ]
            },
            passwordFormValidation: true,
        };
    },

    methods: {
        ...mapActions(["LogOut"]),
        async savePassword() {
            if( this.$refs.formEditPassword.validate()){
                if (sha3_512(this.currentPassword.value) !== this.user.password) {
                    this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.account.changePassword.youenteredabadcurrentpassword'));
                    return;  
                } 

                if (this.newPassword.value !== this.confirmationPassword.value ){
                    this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.account.changePassword.yournewpassworddoesntmatchwithpasswordconfirmation'));
                    return; 
                }
                
                if(this.newPassword.value === this.currentPassword.value) {
                    this.$refs.overlay.showOverlay("error", this.$vuetify.lang.t('$vuetify.account.changePassword.yournewpasswordisthesamethanthecurrentone'));
                    return; 
                }
                try {
                    const res = await axios.put('users/changePassword', {
                        email: this.user.email,
                        password: sha3_512(this.newPassword.value)
                    });
                    if (res.status == 200) {
                        this.$refs.overlay.showOverlay("success", this.$vuetify.lang.t('$vuetify.account.changePassword.passwordChangedOK'));
                    }
                } catch(error) {
                    this.$refs.overlay.showOverlay("error", error);
                }
            }
        },

        cancelPasswordDialog() {
            this.$refs.formEditPassword.reset();
            this.$emit("cancel");
        },
        disconnect() {
            this.LogOut();
            this.$router.push("/login");
        },
    },
    computed: {
        ...mapGetters({ user: "StateUser"}),
        passwordChanged() {
            return this.currentPassword.value !== "" || this.newPassword.value !== "" || this.confirmationPassword.value !== "";
        },
        checkIfEmpty() {
            return !(this.currentPassword.value && this.newPassword.value && this.confirmationPassword.value);
        },
    }
};
</script>